import axios from "axios";
import {getToken} from "../auth/service/authService";
import {MembershipRole} from "../models/Membership";
import {BackendUrl} from "../util/config";

const API_BASE = BackendUrl

export async function inviteMemberToOrganization(
    orgId: string,
    email: string,
    role: MembershipRole
): Promise<any> {
    const token = getToken();
    return await axios.post(
        `${API_BASE}/invitations`,
        {
            email,
            role,
            organizationId: orgId,
        },
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
}